import Script from 'next/script';
import {Dispatch, SetStateAction, useEffect} from 'react';

import {footerPaddings} from '../Yandex/utils';

type Props = {
  slotId: string;
  setIsSSPShown: Dispatch<SetStateAction<boolean>>;
  isAuthFinished?: boolean;
  userInfo?: {
    first_name?: string;
    photo_200?: string;
    id?: number | undefined;
  };
  sspAdsAuthEnabled?: boolean;
  SSP_URL: string;
  SSP_SCRIPT_URL: string;
  logTmrEvent: any;
  emitYmEvent: any;
};

const NOT_EXIST_USER = {id: -1};

export const ExternalSSP = ({
  slotId,
  setIsSSPShown,
  isAuthFinished,
  userInfo,
  sspAdsAuthEnabled,
  emitYmEvent,
  logTmrEvent,
  SSP_SCRIPT_URL,
  SSP_URL,
}: Props) => {
  useEffect(() => {
    if (sspAdsAuthEnabled && isAuthFinished && !userInfo?.id) {
      setIsSSPShown(false);
    }
  }, [isAuthFinished, setIsSSPShown, sspAdsAuthEnabled, userInfo?.id]);
  useEffect(() => {
    //Костыль т.к. SSP не отдает свои размеры
    footerPaddings.add(100);

    return () => {
      footerPaddings.remove();
    };
  }, []);

  if (sspAdsAuthEnabled) {
    if (!userInfo?.id || !isAuthFinished) {
      return;
    }
  }
  const onLoad = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ssp?.initSSP({
      userInfo: userInfo ?? NOT_EXIST_USER,
      onClose: () => {
        setIsSSPShown(false);
        footerPaddings.remove();
      },
      logTmrEvent,
      emitYmEvent,
      slotId,
      sspUrl: SSP_URL,
    });
  };

  return <Script id="ssp-ads" src={SSP_SCRIPT_URL} async onLoad={onLoad} />;
};
